// frontend/src/utils/pdfReader.js
import { saveAs } from 'file-saver';
import { Document, Page } from 'react-pdf';
// import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

export const readPDF = async (pdfUrl, fileName) => {
    try {
        const loadingTask = new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', pdfUrl, true);
            xhr.responseType = 'blob';
            xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(xhr.response);
                } else {
                    reject(new Error(`Failed to load PDF (status ${xhr.status})`));
                }
            };
            xhr.onerror = () => reject(new Error('Network error while loading PDF'));
            xhr.send();
        });

        const pdfBlob = await loadingTask;
        const pdfUrlBlob = URL.createObjectURL(pdfBlob);

        // Render PDF using react-pdf
        const pdfElement = (
            <Document file={pdfUrlBlob}>
                {Array.from(new Array(pdfBlob.numPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
            </Document>
        );

        //Convert PDF to PNG images
        const canvasElements = await Promise.all(
            Array.from(new Array(pdfBlob.numPages), async (_, index) => {
                const pageCanvas = await pdfElement
                    .props.children[index]
                    .render({ canvasContext: {} });
        
                return pageCanvas.toDataURL('image/png');
            })
        );

        // Save the images as a single PDF file
        const imagesBlob = new Blob([canvasElements.join('')], { type: 'application/pdf' });
        saveAs(imagesBlob, `${fileName}.pdf`);
    } catch (error) {
        console.error('Error reading PDF:', error);
    }
};



// frontend/src/utils/pdfReader.js

// import { saveAs } from 'file-saver';
// import * as pdfjsLib from 'pdfjs-dist/build/pdf';

// // Function to open and read a PDF file
// export const readPDF = async (pdfUrl, fileName) => {
//     try {
//         const loadingTask = pdfjsLib.getDocument(pdfUrl);
//         const pdfDocument = await loadingTask.promise;
//         const numPages = pdfDocument.numPages;

//         // Generate an array of promises to load each page
//         const pagePromises = Array.from({ length: numPages }, (_, index) => {
//             return pdfDocument.getPage(index + 1).then(page => {
//                 const scale = 1.5;
//                 const viewport = page.getViewport({ scale });
//                 const canvas = document.createElement('canvas');
//                 const context = canvas.getContext('2d');
//                 canvas.height = viewport.height;
//                 canvas.width = viewport.width;

//                 const renderContext = {
//                     canvasContext: context,
//                     viewport: viewport,
//                 };

//                 return page.render(renderContext).promise.then(() => {
//                     return canvas.toDataURL('image/png');
//                 });
//             });
//         });

//         // Wait for all pages to be loaded
//         const pageImages = await Promise.all(pagePromises);

//         // Save the images as a single PDF file
//         const pdfBlob = new Blob([pageImages.join('')], { type: 'application/pdf' });
//         saveAs(pdfBlob, `${fileName}.pdf`);
//     } catch (error) {
//         console.error('Error reading PDF:', error);
//     }
// };
